import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

export const ENTER_TOUCH_DELAY = 700;
export const LEAVE_TOUCH_DELAY = 1500;

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    enterDelay={500}
    enterTouchDelay={ENTER_TOUCH_DELAY}
    leaveTouchDelay={LEAVE_TOUCH_DELAY}
    onContextMenu={(event) => event.preventDefault()}
    {...props}
    classes={{ popper: className }}
    slotProps={{
      popper: {
        modifiers: [
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              altAxis: true,
              padding: 8,
            },
          },
        ],
      },
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[3],
    border: `1px solid ${theme.palette.divider}`,
    maxWidth: 600,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    fontSize: "large",
    "&::before": {
      backgroundColor: theme.palette.common.white,
      border: `1px solid ${theme.palette.divider}`,
    },
  },
}));

export default LightTooltip;
